import { useMutation, useQueryClient } from '@tanstack/react-query';
import { METHOD, sendRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';
import type { DeleteSessionDto } from '@/types/dtos/sessions/request/delete-session.dto.ts';
import { GET_EVENT_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-event-sessions.ts';
import { GET_EVENT_CONTRIBUTORS_QUERY_KEY } from '@/state/queries/contributors/use-get-event-contributors.ts';
import { GET_EVENT_FILTERED_SESSIONS_QUERY_KEY } from '@/state/queries/sessions/use-filtered-event-sessions';

export const useDeleteSessionMutation = () => {
  const { getToken } = useAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (deleteSessionDto: DeleteSessionDto) => {
      const token = await getToken();
      return deleteSession(deleteSessionDto, token ?? '');
    },
    onSuccess: () => {
      return Promise.all([
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_SESSIONS_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_FILTERED_SESSIONS_QUERY_KEY] }),
        queryClient.invalidateQueries({ queryKey: [GET_EVENT_CONTRIBUTORS_QUERY_KEY] }),
      ]);
    },
  });
};

const deleteSession = async (deleteSessionDto: DeleteSessionDto, token: string) => {
  const url = `${import.meta.env.VITE_API_URL}/sessions/${deleteSessionDto.sessionId}`;
  return sendRequest({ url, method: METHOD.DELETE, token });
};
